"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyrightControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var container_1 = require("../controls/container");
var react_1 = require("@iconify/react");
var label_1 = require("../controls/label");
var CopyrightControl = function (props) {
    var _a = props.company, company = _a === void 0 ? "DoshX" : _a, year = props.year, _b = props.textColor, textColor = _b === void 0 ? "text-black" : _b, _c = props.size, size = _c === void 0 ? "medium" : _c, _d = props.backgroundColor, backgroundColor = _d === void 0 ? "bg-green-400" : _d, _e = props.addPadding, addPadding = _e === void 0 ? false : _e, _f = props.useScreenContainer, useScreenContainer = _f === void 0 ? false : _f, _g = props.position, position = _g === void 0 ? "left" : _g;
    var determinIconSize = function () {
        switch (size) {
            case "xsmall":
                return "text-xs";
            case "small":
                return "text-sm";
            case "medium":
                return "text-md";
            case "large":
                return "text-lg";
        }
    };
    var determinePosition = function () {
        switch (position) {
            case "left":
                return "justify-start";
            case "center":
                return "justify-center";
            case "right":
                return "justify-end";
        }
    };
    var generateCopyright = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row gap-x-1 items-center ".concat(determinePosition()), children: [(0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "mdi:copyright", className: "".concat(determinIconSize(), " ").concat(textColor) }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Copyright ".concat(year ? year : new Date().getFullYear(), "."), textColor: textColor, size: size }), company && (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Powered by ".concat(company), textColor: textColor, size: size })] }));
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(backgroundColor, " ").concat(addPadding && "py-4"), children: useScreenContainer ? (0, jsx_runtime_1.jsx)(container_1.Container, { children: generateCopyright() }) : generateCopyright() }));
};
exports.CopyrightControl = CopyrightControl;
